class AegisReport {
  queue = {
    report: [],
    infoAll: [],
    error: [],
    reportEvent: []
  };
  eventId : any = null;
  time = 1000;
  maxNum = 10;
  num = 0;
  /** *
   *
   * @param time -延迟的毫秒数
   */
  constructor (time = 1000) {
    this.time = time;
  }

  /**
   * 初始化延迟上报事件
   *
   * @private
   */
  _initEvent () {
    this.eventId = setTimeout(() => this._cleanQueue(), this.time);
  }

  /**
   * 将没有上报成功的请求存入队列
   *
   * @private
   */
  _cacheLog (type, info) {
    if (this.eventId === null) {
      this._initEvent();
    }
    this.queue[type].push(info);
  }

  /**
   * 清空队列，发送所有上报请求
   *
   * @private
   */
  _cleanQueue () {
    const win :any = window;
    if (win.aegis) {
      for (let key in this.queue) {
        this.queue[key].forEach(value => {
          // win.aegis[key](value);
          this._doReport(key, value);
        });
        this.queue[key] = [];
      }
      this.eventId = null;
    } else {
      this.num++;
      if ((this.queue.report.length > 0 || this.queue.infoAll.length > 0 || this.queue.error.length > 0 || this.queue.reportEvent.length > 0)
        && this.num <= this.maxNum) this._initEvent();
    }
  }

  /**
   * 执行具体的上报
   *
   * @private
   */
  _doReport(type, info) {
    const win :any = window;
    if (!win.aegis) {
      this._cacheLog(type, info);
      return;
    }
    win.aegis[type](info);
  }

  _formatInfo (info) {
    if (typeof info === "object") {
      const { msg = '', ext1, ext2, ext3 } = info || {};
      return {
        ext1,
        ext2,
        ext3,
        msg: msg || info
      }
    }
  }

  // 页面数据上报
  dataReport (info) {
    if (!info) {
      return;
    }
    if (typeof info === "object") {
      const { ext1, ext2, ext3, name } = info;
      if (name) {
        this.reportEvent({
          ext1,
          ext2,
          ext3,
          name
        });
      }
      this.report(this._formatInfo(info));
    } else {
      this.report(info);
    }
  }

  // level = 2
  state (info) {
    this._doReport('infoAll', info);
  }

  // level = 2048
  report (info) {
    this._doReport('report', info);
  }

  // level = 4
  error (info) {
    this._doReport('error', info);
  }

  // 事件上报
  reportEvent (info) {
    this._doReport('reportEvent', info);
  }
}

const log = new AegisReport();

export default log;
